import { render, staticRenderFns } from "./PaginationTeacher.vue?vue&type=template&id=9b79ad34&scoped=true"
import script from "./PaginationTeacher.vue?vue&type=script&lang=js"
export * from "./PaginationTeacher.vue?vue&type=script&lang=js"
import style0 from "./PaginationTeacher.vue?vue&type=style&index=0&id=9b79ad34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b79ad34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b79ad34')) {
      api.createRecord('9b79ad34', component.options)
    } else {
      api.reload('9b79ad34', component.options)
    }
    module.hot.accept("./PaginationTeacher.vue?vue&type=template&id=9b79ad34&scoped=true", function () {
      api.rerender('9b79ad34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/v2/PaginationTeacher.vue"
export default component.exports